import { render, staticRenderFns } from "./projectFanJing.vue?vue&type=template&id=f787f7b4&scoped=true&"
import script from "./projectFanJing.vue?vue&type=script&lang=js&"
export * from "./projectFanJing.vue?vue&type=script&lang=js&"
import style0 from "./projectFanJing.vue?vue&type=style&index=0&id=f787f7b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f787f7b4",
  null
  
)

export default component.exports